import React, { useEffect, useState } from "react";
import images from "../../../assets/images/constantImages";
import { Link } from "react-router-dom";
import { allOrders } from "../../CanteenUsers/OrderSlice";
import { useDispatch, useSelector } from "react-redux";
import ViewOrder from "./ViewOrder";

const OrdersDB = () => {
  const dispatch = useDispatch();
  const { orders = [] } = useSelector((state) => state.orders || {});
  const [isViewOpen, setIsViewOpen] = useState(null)

  const handleVieOrder = (id) => {
    setIsViewOpen(prev => (prev === id ? null : id));
  };
 const canteenType = useSelector((state) => state.canteenType.type);

useEffect(() => {
  dispatch(allOrders(canteenType));
}, [canteenType, dispatch]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    };
    return date.toLocaleString('en-US', options);
  };

  return (
    <div className="flex flex-col">
      <div className="flex justify-between mb-2">
        <p className="text-2xl font-semibold text-G800">Orders</p>
        <Link to="/mainDashboard/dashboardCt/allOrdersDetails"
          state={{ type: 'pending' }}>
          <p className="font-medium text-green700">View All</p>
        </Link>
      </div>

      <div className="">
        {orders?.filter(order => order.status === "pending").length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {orders
              ?.filter(order => order.status === "pending")
              .slice(0, 4)
              ?.map((order, index) => (
                <div key={index} className={`bg-white rounded-2xl p-4 flex flex-col justify-between border-2 border-white overflow-x-auto`}>
                  <div className="flex justify-between text-G500">
                    <p className="text-sm font-semibold">
                      Order ID <span className="text-base">{order.order_uniq_id}</span>
                    </p>
                    <p className="text-xs font-medium">{order.user.full_name}</p>
                  </div>
                  <div className="flex justify-between text-G100 text-xs mt-2">
                    <p>{formatDate(order.date)}</p>
                    <p className={`text-white rounded-lg px-2 py-1 ${order.status === "pending" ? "bg-yellow " : order.status === "completed" ? "bg-green700" : "bg-red"}`}>
                      {order.status}
                    </p>
                  </div>
                  <div className="flex flex-col gap-2 text-G500 text-sm my-2 max-h-32 overflow-y-auto vertical">
                    {order.order_items.map((item, idx) => (
                      <div
                        key={idx}
                        className="flex justify-between items-center gap-3"
                      >
                        <div className="flex items-center justify-between ">
                          <p className="w-52 flex items-center overflow-x-auto">
                            <img
                              src={item.image}
                              alt={item.item_name}
                              className="w-8 h-8 rounded-full mr-3"
                            />
                            {item.item_name}
                          </p>
                          <h1>X{item.quantity}</h1>
                        </div>
                        <div className="font-medium">₹ {item.total_price}</div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-auto">
                     <hr className="border-b-[1px] border-G20 mb-2" />
                    <div className="flex justify-between items-center text-G500">
                      <p className="font-semibold text-lg flex">
                        <span className="text-green700 mr-1">₹</span>
                        {order.total_price}
                      </p>
                      {/* <Link to={`/mainDashboard/dashboardCt/viewOrder/${order.id}}`}> */}
                      <button onClick={() => handleVieOrder(order.id)} className="bg-green50 rounded-lg px-4 py-1 text-green text-sm font-medium">
                        View Order
                      </button>
                      {isViewOpen === order.id && (
                        <ViewOrder
                          isOpen={true}
                          onClose={() => handleVieOrder(null)}
                          id={order.id}
                        />
                      )}

                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        ) : (<div className="w-full flex justify-center items-center mt-5">
          <img src={images.noorderimagedash} alt="noorderimage" className="object-cover w-40 h-40 bg-cover bg-center" />

          {/* <span className="bg-canteengreen text-white font-semibold px-4 py-1 rounded-md cursor-pointer"></span> */}
        </div>)}
      </div>
      <div className="flex justify-between items-center">
        <div className="text-2xl font-semibold text-G800 mt-5 mb-3">
          Closed Orders
        </div>
        <Link to="/mainDashboard/dashboardCt/allOrdersDetails"
         state={{ type: 'closed' }}>
          <p className="font-medium text-green700">View All</p>
        </Link>
      </div>
      <div className="">
        {orders?.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {orders
              ?.filter(order => order.status !== "pending")
              ?.slice(0, 4).map((order, index) => (
                <div key={index} className={`bg-white  rounded-2xl p-4 flex flex-col justify-between border-2 border-white`}>
                  <div className="flex justify-between text-G500">
                    <p className="text-sm font-semibold">
                      Order ID <span className="text-base">{order.order_uniq_id}</span>
                    </p>
                    <p className="text-xs font-medium">{order.user.full_name}</p>
                  </div>
                  <div className="flex justify-between text-G100 text-xs mt-2">
                    <p>{formatDate(order.date)}</p>
                    <p className="bg-white  text-green700 rounded-lg px-2 py-1">
                      Customer
                    </p>
                  </div>
                  <div className="flex flex-col gap-2 text-G500 text-sm my-2 max-h-32 overflow-y-auto vertical">
                    {order.order_items.map((item, idx) => (
                      <div
                        key={idx}
                        className="flex justify-between items-center gap-3"
                      >
                        <div className="flex items-center justify-between ">
                          <p className="w-52 flex items-center overflow-x-auto">
                            <img
                              src={item.image}
                              alt={item.item_name}
                              className="w-8 h-8 rounded-full mr-3"
                            />
                            {item.item_name}
                          </p>
                          <h1>X{item.quantity}</h1>
                        </div>
                        <div className="font-medium text-nowrap">₹ {item.total_price}</div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-auto">
                    <hr className="border-b-[1px] border-G20 mb-2" />
                    <div className="flex justify-between items-center text-G500">
                      <p className="font-semibold text-lg flex">
                        <span className="text-green700 mr-1">₹</span>
                        {order.total_price}
                      </p>
                      <div className={`text-center text-sm py-[6px] px-4 rounded-md text-white ${order.status === "pending" ? "bg-yellow " : order.status === "completed" ? "bg-green700" : "bg-red"}`}>
                        {order.status}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        ) : (<div className="flex justify-center items-center mt-10">

          <span className="text-G500 font-semibold">No Closed Orders </span>
        </div>)}
      </div>
    </div>
  );
};

export default OrdersDB;
